import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { IdName } from 'app/shared/models/standard.models';

@Component({
  selector: 'case-file-folder',
  templateUrl: './case-file-folders.component.html',
  styleUrls: ['./case-file-folders.component.css']
})
export class CaseFileFoldersComponent implements OnInit, OnChanges {
  @Input() folder: any;
  @Input() level: number; // Used for child indentation
  @Input() selected: string;

  @Output() selectedChange = new EventEmitter<any>();
  @Output() drop = new EventEmitter<any>();
  @Output('rename') folderRenamingEmitter = new EventEmitter<{id:string, name:string}>() 

  addFileHover: boolean = false;
  rename:boolean = false;
  renameCount:number = 0;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.selected && !!changes.selected.currentValue && changes.selected.currentValue != this.folder.id && !!this.folder.children.length) {
      this.hasSelectedChild(this.folder.children);
    }
    if(!!changes.folder && !!changes.folder.currentValue){
      if(!!this.folder.children && !!this.folder.children.length){
        this.folder.children = this.folder.children.sort((a,b)=> a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1)
      }
    }
  }

  folderClick(event) {
    this.renameCount ++;
    if(!!this.folder.parentId) {
      setTimeout(()=> {
        if(this.renameCount > 1) { this.rename = true; }
        this.renameCount = 0;
      },300);
    }
  }

  renameFolder(){
    this.emitFolderRename({
      id: this.folder.id,
      name: this.folder.name
    });
    this.rename = false;
  }

  emitFolderRename(idName: IdName){
    this.folderRenamingEmitter.emit(idName)
  }

  droppedOnFolder(event) {
    event.preventDefault();
    this.addFileHover = false;
    let newFiles = event.dataTransfer.files;
    // let moveFiles = event.dataTransfer.getData('text');
    let moveFiles = 'Component does not know which files will be moved. Use selected files in current folder to filter files and folders to be moved';
    if (!!newFiles || !!moveFiles) {
      this.drop.emit(
        {
          folderId: this.folder.id,
          content: !!newFiles.length ? newFiles : moveFiles,
          type: !!newFiles.length ? 'add' : 'move'
        }
      )
    }
  }

  hasSelectedChild(folder) {
    folder.forEach(x => {
      if (this.selected == x.id) this.folder.open = true;
      else if (!!x.children.length) this.hasSelectedChild(x.children);
    })
  }

  isChildOpen(event) {
    // console.log(event)
  }
}
